import { httpsCallable } from "firebase/functions"
import { functions } from "../firebaseFunctions"

export type CommentNotification = {
  id: string; publicationPath: string; commentId: string; rootId: string;
  name: string; avatar: string; type: "comment" | "reply"; preview: string;
  publicationTitle: string; publicationImage: string; createdAt: number; read: boolean;
}
export type NotificationPage = { items: CommentNotification[]; cursor: { id: string; time: number } | null }
const endpoint = httpsCallable(functions, "commentNotifications")
export const NOTIFICATIONS_CHANGED = "comment-notifications-changed"
export async function notificationsRequest<T = any>(action: string, data: Record<string, unknown> = {}): Promise<T> {
  return (await endpoint({ ...data, action })).data as T
}
